import logo from './assets/shared/logo.svg';
import "./styles/navbar.css";
import open from './assets/shared/icon-hamburger.svg';
import close from './assets/shared/icon-close.svg';
import { Link } from 'react-router-dom';
import { useState } from 'react';



const Navbar = () => {

    const [openMenu, setOpenMenu] = useState(false);

    return ( 
        <nav>
            <div className="mainLogo">
               <Link to="/"> <img src={logo} alt="site logo" className="logo" /></Link>
            </div>
            <div className="midline"></div>
            <img src={open} alt="open menu" className='openMenu' onClick={() => setOpenMenu(true)} />
            
            <div className={`leftContainer ${openMenu ? "openMenuCont" : ""}`} >

                <img src={close} alt="close menu"  className='closeMenu' onClick={() => setOpenMenu(false)}/>
                
                <ul className="navLinks">
                    <li ><Link to="/" onClick={()=>setOpenMenu(false)}>00 HOME</Link></li>
                    <li ><Link to="/dest" onClick={()=>setOpenMenu(false)}>01 DESTINATION</Link></li>
                    <li ><Link to="/crew" onClick={()=>setOpenMenu(false)}>02 CREW</Link></li>
                    <li ><Link to="/tech" onClick={()=>setOpenMenu(false)}>03 TECHNOLOGY</Link></li>
                </ul>
            </div>
        </nav>
     );
}
 
export default Navbar;